export const callTypes = t => [
  { value: 'OUTGOING', name: t('clientCall.type.outgoing', 'Wychodzące') },
  { value: 'INCOME', name: t('clientCall.type.incoming', 'Przychodzące') },
];
